module.exports = __webpack_public_path__ + "img/img6.6e5c516.png";